import { DataView } from 'primereact/dataview';
import { Dropdown } from 'primereact/dropdown';
import { SelectButton } from 'primereact/selectbutton';
import { useEffect, useState } from 'react';
import PageWrapper from '../../../../components/Display/PageWrapper';
import { useAccountContext } from '../../../../contexts/AccountContext';
import { useNavigationContext } from '../../../../contexts/NavigationContext';
import { privateFetch } from '../../../../utils/apiHelper';
import { CONSTANT } from '../../../../utils/constants';
import PillsItem from './PillsItem';
import PillsManager from './PillsManager';

function PillsPage({ isActive }) {
  const { accountContext } = useAccountContext();
  const { navigationContext } = useNavigationContext();
  const [pillsList, setPillsList] = useState([]);
  const [pillsDetail, setPillsDetail] = useState(undefined);
  const [panelIsOpen, setPanelIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [typeFilter, setTypeFilter] = useState(undefined);

  useEffect(() => {
    fetchPillsList();
  }, [typeFilter, navigationContext]);

  const fetchPillsList = async () => {
    await privateFetch(
      'GET',
      'quatrebis',
      `/cu/${accountContext.id}/pills/?page=${typeFilter || ''}`
    ).then((res) => {
      setPillsList(res);
    });
  };

  const handleClickPills = (pills) => {
    setPillsDetail(pills);
    setPanelIsOpen(true);
  };

  useEffect(() => {
    if (panelIsOpen === false) {
      setPillsDetail(undefined);
    }
  }, [panelIsOpen]);

  const handleOpenManager = () => {
    setPanelIsOpen(true);
  };

  const newPillsAction = {
    onClick: handleOpenManager,
    label: 'Ajouter une information',
    icon: 'pi-plus'
  };

  const createPills = async (pillsForm) => {
    setLoading(true);
    await privateFetch(
      'POST',
      'quatrebis',
      `/cu/${accountContext.id}/pills/`,
      "L'information a bien été ajoutée",
      JSON.stringify(pillsForm)
    ).then(() => {
      fetchPillsList();
      setPanelIsOpen(false);
      setLoading(false);
      setPillsDetail(undefined);
    });
  };

  const uppillsPills = async (pillsForm) => {
    setLoading(true);
    await privateFetch(
      'PUT',
      'quatrebis',
      `/cu/${accountContext.id}/pills/${pillsDetail.id}/`,
      "L'information a bien été modifiée",
      JSON.stringify(pillsForm)
    ).then(() => {
      fetchPillsList();
      setPanelIsOpen(false);
      setLoading(false);
    });
  };

  const deletePills = async (pills) => {
    await privateFetch(
      'DELETE',
      'quatrebis',
      `/cu/${accountContext.id}/pills/${pills.id}/`,
      "L'information a bien été supprimée"
    ).then(() => {
      fetchPillsList();
      setPillsDetail(undefined);
    });
  };

  const itemTemplate = (pills) => (
    <PillsItem pills={pills} handleClickPills={() => handleClickPills(pills)} />
  );

  const pillsFilters = (
    <div className="flex flex-row flex-wrap gap-2 justify-start">
      <div className="flex flex-row flex-wrap gap-2 ">
        <div className="fit-content mb-4">
          <Dropdown
            value={typeFilter}
            options={CONSTANT.quatrebis.pillsType}
            optionLabel="label"
            onChange={(e) => setTypeFilter(e.value)}
            placeholder="Filtrer par page"
            className="grow rounded-full pl-2"
            filter
            showClear
          />
        </div>
      </div>
    </div>
  );

  return (
    <div className={`h-full w-full flex-col ${isActive ? 'flex' : 'hidden'}`}>
      <PageWrapper
        label="Informations dynamiques complémentaires (rectangles jaunes)"
        labelAction={handleClickPills}
        action={newPillsAction}>
        {pillsFilters}
        <DataView
          value={pillsList}
          itemTemplate={itemTemplate}
          className="pb-20"
          emptyMessage="Aucune information trouvé"
        />
      </PageWrapper>
      <PillsManager
        isOpen={panelIsOpen}
        onClose={() => {
          setPanelIsOpen(false);
        }}
        pills={pillsDetail}
        onCreate={createPills}
        onUppills={uppillsPills}
        loading={loading}
        setPanelIsOpen={setPanelIsOpen}
        setPillsDetail={setPillsDetail}
        handleDelete={deletePills}
      />
    </div>
  );
}

export default PillsPage;
